module.exports = __webpack_public_path__ + "static/08-3d5cb361ff4c8b0ecd5277c6d08cdb93.jpg";